import { useEffect } from 'react';
import './About.css'
import Navbar from '../Components/navbar'
import Footer from '../Components/Footer';
import BAN4 from '../images/BAN4.jpg'
export default function About() {



  useEffect(() => {
       window.scrollTo(0, 0); 
     }, []);

  return (
    <>
    
    
  <Navbar/>
    <section id='top'>
    <div className='cotainer'>
      <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
          <img src={BAN4} alt='' title='' className='img-fluid'/>
        </div>
        <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
          <p>Your destination for precision machining solutions. Originally a stockist for carbide cutting tools, we've evolved to meet industry demands. Since 2000, we've been at the forefront, introducing high-end CNC carbide tooling for sectors like automotive, aerospace, and more.</p>
          <p>Your destination for precision machining solutions. Originally a stockist for carbide cutting tools, we've evolved to meet industry demands. Since 2000, we've been at the forefront, introducing high-end CNC carbide tooling for sectors like automotive, aerospace, and more.</p>
          <p>Your destination for precision machining solutions. Originally a stockist for carbide cutting tools, we've evolved to meet industry demands. Since 2000, we've been at the forefront, introducing high-end CNC carbide tooling for sectors like automotive, aerospace, and more.</p>
          <p>As authorized agents for top brands, including Indoloy Sriram and Shiballoy, we guarantee quality. Our portfolio caters to enterprises of all sizes, providing cutting-edge solutions in turning, milling, threading, and more.</p>
        </div>
      </div>
    </div>
    </section>




    <section id='vmu'>
    <div className='container'>
<div className='row'>

<div className='col-lg-12 col-md-12 col-sm-12 col-12' id='bor'>
  <h3>Our Vision</h3>
<p>"OM Enterprise’s vision is to be the world leader in manufacturing engineering products and delivering related services. We are a company that never compromises on quality. With our premium-quality products, we aim to make a strong mark globally."

</p>
</div>


<div className='col-lg-12 col-md-12 col-sm-12 col-12' id='bor'>
  <h3>Our Mission</h3>
  <p>“OM Enterprise aims to grow in the global market by providing the best quality products and services that fulfill customer needs, while building positive and long-lasting relationships with our customers.”</p>
</div>

<div className='col-lg-12 col-md-12 col-sm-12 col-12' id='bor'>
  <h3>Why Us</h3>
  <p><strong>100% Genuine</strong>
Products
We provide high
quality genuine
products.
</p>
<p><strong>Product
Knowledge</strong>
Our knowledge
helps us choose
the right tools for
the right job.</p>


<p><strong>Sole
Distributors</strong>
For brands like
Speed Tiger,
JJ Tools, Hardaloy,
Noburr</p>
<p><strong>Flexibility in
Dealing</strong>
Flexibility in dealing
and a customer
centric approach
</p>



<p><strong>Preferred
Choice</strong>
for many
clients in the
metal-cutting
industry</p>


</div>


</div>
</div>
</section>
<Footer/>
    </>
  )
}
